<template>
    <el-dialog :visible.sync="show"
        :title="$t('privateNetInstance.unBindTitle')"
        :close-on-click-modal="false"
        :before-close="handleClose"
        size="small"
        class="del-root">
        <div>
            <p v-if="rowInfo.instanceType=='cps'">{{$t('eip.help.confirmToUnbind', [rowInfo.elasticIp, rowInfo.targetIp || rowInfo.aliasIp, rowInfo.targetIp ?
                            `(${$t('subnet.text.privateIp')})` : `(${$t('eip.text.ipAlias')})`])}}</p>
            <p v-else-if="rowInfo.instanceType=='cpslb'">{{$t('eip.help.confirmToUnbindSlb',[rowInfo.elasticIp,rowInfo.instanceName])}}</p>
            <p v-else-if="rowInfo.instanceType=='cpsnat'">{{$t('eip.help.confirmToUnbindNat',[rowInfo.elasticIp,rowInfo.instanceName])}}</p>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelUnbind">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="sureUnbind" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'UnBindEip',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rowInfo: {
            type: Object,
            default: {}
        },
        region: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false
        };
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        cancelUnbind() {
            this.handleClose();
        },
        sureUnbind() {
            let instanceType = this.rowInfo.instanceType;
            const params = {
                region: this.region,
            };
            let url = '';
            let unbindRequest;
            if(instanceType === 'cps'){
                params.elasticIpId = this.rowInfo.elasticIpId;;
                params.instanceId = this.rowInfo.instanceId;
                url = '/api/cps/disassociateElasticIp';
                unbindRequest = Ajax.put(url, params);
            }else if (instanceType === 'cpslb') {
                params.elasticIpId = this.rowInfo.elasticIpId;
                params.loadBalancerId = this.rowInfo.instanceId;
                url = '/api/cps/slbs/disassociateElasticIp';
                unbindRequest = Ajax.put(url, params);
            } else if (instanceType === 'cpsnat') {
                let elasticIpId = this.rowInfo.elasticIpId;
                params.az = this.rowInfo.az;
                params.eipIds = [elasticIpId];
                params.natGatewayId = this.rowInfo.instanceId;
                params.type = 'disassociate';
                url = '/api/cps/nat/operateBind';
                unbindRequest = Ajax.put(url, params,{
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            }
            unbindRequest
            .then((res) => {
                if(instanceType === 'cpsnat') {
                    this.$message.success(this.$t('privateNetInstance.operateSuccess'));
                }
                
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
                this.$emit('refresh');
            });
           
        }
    },
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: center;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/eip/UnBindSource.vue